import 'bootstrap/js/dist/modal';
import '../scss/style.scss';
import './admin-page';
import './wpacode-parameter';
import './mediator/contact-form';